import ApiService from '../apiservice'

export default class PublicacoesService extends ApiService {
  constructor() {
    super('/publicacoes')
  }

  consultarPublicacoes(filtro) {
    return this.get(`/filtro?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&pessoa=${filtro.pessoa}&numeroProcesso=${filtro.numeroProcesso}&advogado=${filtro.advogado}`);
  }
}